import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import type { ApiLabouring } from "@src/api/dictionaries/labouring";
import type { ApiSessionUser } from "@src/api/users";
import { isZustandDevtoolsEnabled } from "./zustandDevtoolsEnabled";

interface UserState {
    currentUser: ApiSessionUser | null;
    labouring: ApiLabouring | null;
}

interface UserStateActions {
    setCurrentUser: (currentUser: ApiSessionUser) => void;
    setLabouring: (labouring: ApiLabouring) => void;
    setUserData: (data: { currentUser: ApiSessionUser; labouring: ApiLabouring | null }) => void;
    clearStore: () => void;
}

const initialState: UserState = {
    currentUser: null,
    labouring: null,
};

/**
 * App-level store текущего пользователя и работника.
 */
export const useUserStore = create<UserState & UserStateActions>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,
                setCurrentUser: (currentUser) => {
                    set({ currentUser }, false, "setCurrentUser");
                },
                setLabouring: (labouring) => {
                    set({ labouring }, false, "setLabouring");
                },
                setUserData: ({ currentUser, labouring }) => {
                    set({ currentUser, labouring }, false, "setUserData");
                },
                clearStore: () => {
                    set(initialState, false, "clearStore");
                },
            }),
            {
                name: "current-user-store",
                version: 2,
                partialize: (state) => ({
                    currentUser: state.currentUser,
                    labouring: state.labouring,
                }),
            },
        ),
        {
            name: "current-user-store",
            enabled: isZustandDevtoolsEnabled,
            trace: true,
        },
    ),
);

export default useUserStore;
